<template>  
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>  
        <v-card>
          <v-toolbar flat>      
            <v-text-field flat dense filled
              v-model="term"
              append-icon="search"
              label="Search"
              single-line
              hide-details        
              @input="search"
              style="max-width:200px"
            ></v-text-field>                 
            <v-spacer/>
            <v-btn fab color="green" dark small right :to="{name:'adm/quetionnaire/form'}"><v-icon>add</v-icon></v-btn>                      
          </v-toolbar>
          <v-card-text class="pa-0">      
            <v-container fluid grid-list-lg class="ma-0 pa-0">
              <v-layout row>
                <v-flex xs12 md12 style="position:relative">            
                  <v-data-table dense 
                    :headers="headers"
                    :items="items"              
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    :items-per-page="-1"
                    hide-default-footer  
                    hide-actions
                    :options.sync="pagination" 
                    must-sort                       
                  >               
                    <template slot="items" slot-scope="props"> 
                      <td>{{ ((page-1)*20)+(items.findIndex(x=>x==props.item)+1) }}</td>
                      <td>{{ props.item.description }}</td>
                      <td><v-chip :class="props.item.status === 1 ? 'green white--text':''" small>{{ status[props.item.status] }}</v-chip></td>                      
                      <td><v-chip label :color="props.item.color" small dark>{{ props.item.color }}</v-chip></td>                      
                      <td>{{ props.item.name }}</td>                      
                      <td>
                        <v-btn icon small color="blue" :to="{name:'adm/quetionnaire/form',query:{id:props.item.id}}"><v-icon>edit</v-icon></v-btn>
                        <v-btn v-if="props.item.node_id == -1" icon small color="success" :to="{name:'adm/quetionnaire/view',query:{id:props.item.id}}"><v-icon>touch_app</v-icon></v-btn>
                      </td>
                    </template>              
                  </v-data-table>
                  <div class="text-center">
                    <v-pagination
                      v-model="page"
                      :length="totalPages"
                      circle
                      :total-visible="9"
                    ></v-pagination>
                  </div>
                </v-flex>          
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card> 
      </v-container>
    </div>
  </v-slide-y-transition>      
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/master/Quetionnaire'
const  model = new Model()

export default {
  data () {
    return {
      term : null,
      headers:[
        {text:'No', value:'no'},        
        {text:'Name', value:'description'},
        {text:'Status', value:'status'},
        {text:'Code', value:'name'},                
        {text:'Color', value:'color'},
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,      
    }
  },
  computed:{
    status(){
      return {0:'inactive',1:'active'};      
    },    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        sort:sortby,
        //expand:'node'
      }

      model.all(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },    
  },  
}
</script>